var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.recette &&
    _vm.recette.lignesCompletees &&
    _vm.recette.lignesCompletees.length !== 0
    ? _c(
        "div",
        [
          _vm.nomDeRecette
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "flex-center-space-between feuille-papier",
                    staticStyle: {
                      "font-weight": "bolder",
                      "font-size": "120%",
                      padding: "15px 15px 0 15px",
                      "align-items": "start"
                    }
                  },
                  [
                    _c("div", [_vm._v(_vm._s(_vm.recette.nom))]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-left": "10px",
                          "white-space": "nowrap"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("mettreVirgule")(_vm.recette.prixUnitaire)
                          ) +
                            " €/" +
                            _vm._s(
                              _vm.recette.upSingulier
                                ? _vm.recette.upSingulier
                                : _vm.recette.up
                            )
                        )
                      ]
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._m(0),
          _vm._l(_vm.recette.lignesCompletees, function(ligne, index) {
            return _c("div", { key: index, staticClass: "feuille-papier" }, [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-center-space-between",
                      staticStyle: { width: "100%" }
                    },
                    [
                      _c("dropDownChoixFamille", {
                        attrs: { familleSelectionnee: ligne.famille }
                      }),
                      ligne.composant && ligne.famille
                        ? _c(
                            "span",
                            {
                              class: {
                                warningText: _vm.estSansCotation(ligne)
                              },
                              staticStyle: {
                                "margin-right": "auto",
                                "font-weight": "600"
                              }
                            },
                            [
                              _vm._v(" " + _vm._s(ligne.composant.nom) + " "),
                              ligne.grammage
                                ? _c("span", [
                                    _vm._v(" (" + _vm._s(ligne.grammage) + "g)")
                                  ])
                                : _vm._e()
                            ]
                          )
                        : ligne.composant && !ligne.famille
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                "margin-right": "auto",
                                "font-weight": "600"
                              }
                            },
                            [
                              !ligne.famille
                                ? _c("RecettePopUpIngredients", {
                                    attrs: {
                                      estLien: true,
                                      recetteId: ligne.composantId,
                                      recetteNom: ligne.composant.nom
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      ligne.up
                        ? _c("span", { staticClass: "UP-container" }, [
                            _vm._v(
                              _vm._s(_vm._f("mettreVirgule")(ligne.quantite)) +
                                " " +
                                _vm._s(ligne.up)
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              ligne.conviveTypeId &&
              _vm.recette.conviveTypeId !== ligne.conviveTypeId
                ? _c("div", { staticClass: "nom-convive" }, [
                    _vm._v(
                      " " + _vm._s(_vm.nomConviveType(ligne.conviveTypeId))
                    )
                  ])
                : _vm._e(),
              _c("div")
            ])
          }),
          _vm.allergenes
            ? _c(
                "div",
                {
                  staticClass: "feuille-papier",
                  staticStyle: { padding: "15px" }
                },
                [
                  _vm._v(" Allergènes : " + _vm._s(_vm.allergenes) + " "),
                  _vm.recette.saisieAllergenesIncomplete
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "Attention, la liste des allergènes est peut-être incomplète car ils n'ont pas été renseignés pour un ou plusieurs ingrédients"
                        )
                      ])
                    : _vm._e(),
                  _vm._m(1)
                ]
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "flex-center-space-between feuille-papier",
        staticStyle: {
          "background-color": "white",
          "padding-bottom": "1rem",
          padding: "15px 15px 7px 15px"
        }
      },
      [
        _c("div", { staticStyle: { "font-weight": "bolder" } }, [
          _vm._v("Ingrédients")
        ]),
        _c("div", { staticStyle: { "font-weight": "bolder" } }, [
          _vm._v("Qté. brute")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticStyle: { "padding-top": "15px", "font-size": "0.9em" } },
      [
        _c("em", [
          _vm._v(
            "L’affichage des allergènes est effectué à titre informatif. Chaque utilisateur du logiciel doit vérifier par lui-même la véracité de ces informations auprès du ou des fournisseurs de denrées alimentaires concernés."
          ),
          _c("br"),
          _vm._v(
            " En cas d’erreur, l’utilisateur ne pourra pas engager la responsabilité de la société Agap’pro, éditrice du logiciel."
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }